import type { MPLOffer, MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { isMplOffer, isMplPreApprovalOffer } from 'shared/lib';
import type { TOffer, TOfferSummary } from 'shared/types/TRankingService';

export const getAnalyticsSummariesParams = (offer: TOffer | MPLOffer | MPLPreApprovalOffer) => {
  if (isMplOffer(offer) || isMplPreApprovalOffer(offer)) {
    const summariesMap = (offer.summaries || []).reduce<Record<string, NonNullable<typeof offer.summaries>[0]>>(
      (acc, summary) => {
        acc[summary.label] = summary;
        return acc;
      },
      {},
    );

    return {
      psk: summariesMap.LoanPsk?.valueRaw?.toString(),
      sum: summariesMap.LoanAmount?.valueRaw?.toString(),
      rate: summariesMap.LoanRate?.valueRaw?.toString(),
      term: summariesMap.LoanTerm?.valueRaw?.toString(),
    };
  }

  const summariesMap = (offer.summaries || []).reduce<Record<string, TOfferSummary>>((acc, summary) => {
    if (!summary.type) {
      return acc;
    }
    acc[summary.type] = summary;
    return acc;
  }, {});

  return {
    psk: summariesMap.LoanPsk?.value,
    sum: summariesMap.LoanAmount?.value,
    rate: summariesMap.LoanRate?.value,
    term: summariesMap.LoanTerm?.value,
  };
};
